module.exports = ["upravo sad",["prije %s sekunde","prije %s sekundi"],["prije %s minute","prije %s minuta"],["prije %s sata","prije %s sati"],"prije %s dana",["prije %s tjedna","prije %s tjedana"],["prije %s mjeseca","prije %s mjeseci"],["prije %s godine","prije %s godina"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/hr-HR.json
// module id = aoC6
// module chunks = 1